export const NO_ICD_10_CODE = 'NO-ICD-10-CODE';
export const CODE_SYSTEM_ICD_10_INTERNAL = 'http://augmedix.com/ref/fhir/codesystems/internal';
export const CODE_SYSTEM_ICD_10 = 'http://hl7.org/fhir/sid/icd-10';

export interface Code {
  actionSource: string;
  code: string;
  codeSystem: string;
  createdAt: string;
  createdBy: string;
  display: string;
  history: {
    actionSource: string;
    code: string;
    status: string;
    updatedAt: string;
    updatedBy: string;
  };
  id: string;
  noteId: string;
  rank: number;
  reference: any;
  referenceSelection: string;
  referenceType: string;
  status: string;
  updatedAt: string;
  updatedBy: string;
}

export interface TemplateSelection {
  complaintId: number;
  section: string;
  codes: Code[];
  loading?: boolean;
}

export interface NoteContent {
  templateSelection: {
    ComplaintId: number;
    ComplaintName: string;
    codes: Code[];
  };
  Section: string;
}
